import moment from "jalali-moment";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import endpoints from "../../config/endpoints";
import { Sidebar } from "../../layouts/Sidebar";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import DataTable, { Column } from "../../components/DataTable";

const Brand = () => {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const deleteItem = async (id: number) => {
    if (!confirm("آیا مطمئن هستید؟")) return;
    dispatch(setLoading(true));

    const res = await restApi(
      process.env.REACT_APP_BASE_URL + "/admin/brand/" + id,
      true,
    ).delete({});

    if (res.code == 204) {
      Swal.fire({
        title: "موفق",
        text: "برند با موفقیت حذف شد",
        icon: "success",
        confirmButtonText: "متوجه شدم",
        didClose() {
          fetchData();
        },
      });
    } else {
      Swal.fire({
        title: "ناموفق",
        text: res?.data,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }

    dispatch(setLoading(false));
  };

  const columns: Column[] = [
    {
      key: "index",
      title: "ردیف",
      sortable: false,
      searchable: false,
      width: "60px",
      render: (_val, _row, index) => index + 1,
    },
    { key: "title", title: "عنوان" },
    { key: "slug", title: "اسلاگ" },
    { key: "description", title: "توضیحات" },
    {
      key: "createdAt",
      title: "تاریخ ساخت",
      render: (val) => (val ? moment(val).format("jYYYY/jMM/jDD HH:mm") : "—"),
    },
    {
      key: "id",
      title: "عملیات",
      sortable: false,
      searchable: false,
      width: "120px",
      render: (_val, row: any) => (
        <span className="svgContainer">
          <a
            href={`${process.env.REACT_APP_CLIENT_URL}/brand/${row.slug}`}
            target="_blank"
          >
            <i className="eye"></i>
          </a>
          <i className="trash clickable" onClick={() => deleteItem(row.id)}></i>
          <i
            className="edit clickable"
            onClick={() => navigate("/brand/edit/" + row.id)}
          ></i>
        </span>
      ),
    },
  ];

  const fetchData = async () => {
    dispatch(setLoading(true));
    const res = await restApi(endpoints.brand.index).get();
    if (res.code == 200) setData(res.data);
    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <body className="dashboardBody">
        <Sidebar />
        <main className="dashBoardMain">
          <h1 className="dashBoardTitle">لیست برندها</h1>
          <div className="searchContainer">
            <span
              className="dashboardHeader clickable"
              onClick={() => navigate("/brand/add")}
            >
              <p>افزودن برند جدید</p>
              <i className="addPlus"></i>
            </span>
          </div>
          <DataTable columns={columns} data={data} rowKey="id" pageSize={25} />
        </main>
      </body>
    </>
  );
};
export default Brand;
